module.exports = __webpack_public_path__ + "img/receipt-yh-logo.68eaaec3.png";